import { render, staticRenderFns } from "./resource-niche.vue?vue&type=template&id=19233d58&scoped=true"
import script from "./resource-niche.vue?vue&type=script&lang=js"
export * from "./resource-niche.vue?vue&type=script&lang=js"
import style0 from "./resource-niche.vue?vue&type=style&index=0&id=19233d58&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19233d58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19233d58')) {
      api.createRecord('19233d58', component.options)
    } else {
      api.reload('19233d58', component.options)
    }
    module.hot.accept("./resource-niche.vue?vue&type=template&id=19233d58&scoped=true", function () {
      api.rerender('19233d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recommended/resource-niche.vue"
export default component.exports